import RestClient from './RestClient';
import { InAppNotification } from '../models';

class Notifications extends RestClient {
    constructor() {
        super({
            model: InAppNotification,
            entryPoint: 'notifications',
            id_field: '_id',
            resource: 'notification',
            resources: 'notifications',
        });
    }

    unreadCount() {
        return this.GET(`/${this.entryPoint}/unread-count`)
            .then(response => response.json());
    }

    markAsRead(id: string) {
        return this._fetch(`/${this.entryPoint}/${id}/read`, 'PATCH')
            .then(response => response.json())
            .then(json => {
                if (json.notification) {
                    json.notification = new InAppNotification(json.notification);
                    return json;
                }
                throw new Error(json.error || '');
            });
    }

    markAllAsRead() {
        return this.POST(`/${this.entryPoint}/read-all`)
            .then(response => response.json());
    }

    clearAll() {
        return this.POST(`/${this.entryPoint}/clear-all`)
            .then(response => response.json());
    }

    deleteOne(id: string) {
        return this.delete(id);
    }
}

const NotificationsApi = new Notifications();
export default NotificationsApi;
